var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container feedback template-bg-gray",
      class: { "my-position-relative": _vm.isStatus }
    },
    [
      _vm.isStatus
        ? _c(
            "md-card",
            {
              staticClass:
                "request-status loop_container bg-transparent update-request-form-common"
            },
            [
              _c(
                "md-card-content",
                { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main" },
                [
                  _c(
                    "div",
                    { staticClass: "card form-wrapper text-center p-20" },
                    [
                      _c("h4", {
                        staticClass: "template-custom-title",
                        domProps: { innerHTML: _vm._s(_vm.statusMsg) }
                      })
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isStatus
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "loop_container bg-transparent update-request-form-common"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card form-wrapper",
                        class: { thankupageplr88: _vm.success }
                      },
                      [
                        _c("div", { staticClass: "feedback_container" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-md-12 text-center" },
                              [
                                _c("img", {
                                  staticClass: "top-logo custom-logo",
                                  attrs: {
                                    src: _vm.logoURL,
                                    alt:
                                      _vm.community.content &&
                                      _vm.community.content.parameter2
                                        ? _vm.community.content.parameter2
                                        : "Community Logo"
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "header-text common-space-from-logo",
                              class: {
                                "email-actionpage-tmsg plr10": !_vm.success
                              }
                            },
                            [
                              _c(
                                "h1",
                                { staticClass: "template-title text-center" },
                                [_vm._v("Thank you!")]
                              ),
                              _vm._v(" "),
                              !_vm.success
                                ? _c("p", { staticClass: "custom-content" }, [
                                    _vm._v(
                                      "Tell us briefly (confidentially) why you have not engaged further. We want to do a better job setting expectations."
                                    )
                                  ])
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.success,
                                  expression: "!success"
                                }
                              ],
                              staticClass: "template-form",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.submitFollowup()
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "template-input-text-area",
                                      class: [
                                        {
                                          "b-error": _vm.errors.has("comment")
                                        },
                                        "form-group",
                                        "pd-remove",
                                        "unsubscribe-height"
                                      ]
                                    },
                                    [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.comment,
                                            expression: "comment"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate.continues",
                                            value: "required|max:500",
                                            expression: "'required|max:500'",
                                            modifiers: { continues: true }
                                          },
                                          { name: "focus", rawName: "v-focus" }
                                        ],
                                        staticClass: "form-control",
                                        class: {
                                          "request-form-error-border": _vm.errors.has(
                                            "comment"
                                          )
                                        },
                                        attrs: {
                                          name: "comment",
                                          id: "comment",
                                          rows: "10",
                                          placeholder: _vm.commentPlaceholder,
                                          maxlength: _vm.max
                                        },
                                        domProps: { value: _vm.comment },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.comment = $event.target.value
                                            },
                                            _vm.sanitizeComment
                                          ]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has("comment"),
                                              expression:
                                                "errors.has('comment')"
                                            }
                                          ],
                                          staticClass: "error"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.errors.first("comment"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-md-12 text-right" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group pd-remove unsubscribe-btn"
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn template-button btn_info bg-white",
                                            style: _vm.reviewBtn,
                                            attrs: {
                                              type: "submit",
                                              name: "helpAction"
                                            }
                                          },
                                          [_vm._v("Submit")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-inline text-center footer-links" },
                      [
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.landingPageURL &&
                          _vm.community.content.landingPageURL.length
                            ? _c(
                                "a",
                                {
                                  staticClass: "links",
                                  attrs: {
                                    href: _vm.community.content.landingPageURL,
                                    target: "_blank",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Learn More")]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:void(0)",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Learn More")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.termsConditionsURL &&
                          _vm.community.content.termsConditionsURL.length
                            ? _c(
                                "a",
                                {
                                  staticClass: "links",
                                  attrs: {
                                    href:
                                      _vm.community.content.termsConditionsURL,
                                    target: "_blank",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Terms Of Use [pdf]")]
                              )
                            : _c(
                                "a",
                                {
                                  attrs: {
                                    href: "javascript:void(0)",
                                    tabindex: "0"
                                  }
                                },
                                [_vm._v("Terms Of Use [pdf]")]
                              )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm.community.content &&
                          _vm.community.content.unsubscribePageURL &&
                          _vm.community.content.unsubscribePageURL.length
                            ? _c(
                                "a",
                                {
                                  attrs: {
                                    tabindex: "0",
                                    href:
                                      _vm.community.content.unsubscribePageURL,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Opt Out")]
                              )
                            : _c(
                                "a",
                                { attrs: { href: "javascript:void(0)" } },
                                [_vm._v("Opt Out")]
                              )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "unsubscribe-community-logo" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.protopia.co",
                            target: "_blank"
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.footerLogoURL,
                              alt: "Community Logo"
                            }
                          })
                        ]
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e503f3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e503f3d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResponseFollowUp.vue
// module id = null
// module chunks = 